import { Modal } from "antd";
import useNetworkStatus from "../hooks/useNetworkStatus";

export default function InternetAlert() {
  const isOnline = useNetworkStatus();

  return (
    <Modal
      open={!isOnline}
      closable={false}          // ❌ cannot close manually
      maskClosable={false}      // ❌ cannot click outside to close
      footer={null}             // no footer buttons
      centered                  // center popup
      maskStyle={{
        backdropFilter: "blur(4px)", // nice blur background
      }}
    >
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h2 style={{ color: "red", marginBottom: "10px" }}>
          ⚠ No Internet Connection
        </h2>
        <p>Please check your network.<br /> The app will resume once you’re back online.</p>
      </div>
    </Modal>
  );
}
